<template>

	<el-input
		ref="input"
		class="input-llood-text"
		v-model="model"
		v-bind="{...$attrs, ...$props}"
	/>

</template>

<script>
	export default {
		name: 'InputLloodText',
		props: {
			value: {
				default: ''
			}
		},
		computed: {

			model: {

				get () { return this.value },

				set (val) { this.$emit('input', val) }

			}

		},
		methods: {

			focus () { setTimeout(() => this.$refs.input.focus(), 200) },

			select () { setTimeout(() => this.$refs.input.select(), 200) }
		}
	}
</script>
